module.exports = __webpack_public_path__ + "img/Number=36.92a77e1e.png";